import script from "./RcDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdown.vue?vue&type=style&index=0&id=7d36bce9&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d36bce9"]])

export default __exports__